/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState } from "react";
import PropTypes from "prop-types";
import gl_arrow_down from "../../assets/gl_arrow_down.svg";
import gl_arrow_up from "../../assets/gl_arrow_up.svg";
import profile from "../../assets/ic_profile.svg";
import manual from "../../assets/instruction-manuals-book.jpg";
import "./styles.scss";
import Button from "../common/Button";
import { CONSTANTES } from "../../utils/Constantes";
import { callService } from "../../amplify/callService";

const ButtonHeaderDesktop = ({ username, handleLogout }) => {
  const [showOptions, setShowOptions] = useState(false);

  const handleShowOptions = () => {
    setShowOptions(!showOptions);
  };
  const downloadManual = async () => {
    let file= process.env.REACT_APP_URL_MANUAL
    
    let obj = {
      payload: {
      },
    };
    let response = await callService(
      "POST",
      CONSTANTES.APIS_PATH.getUrlManual,
      obj
    );
    if (response.ok) {
      fetch(response.data, { method: "GET" })
        .then((response) => response.blob())
        .then((blob) => {
          var url = window.URL.createObjectURL(blob);
          var a = document.createElement("a");
          a.href = url;
          let nameFile = "Manual de Usuario.pdf";
          a.download = nameFile;
          document.body.appendChild(a);
          a.click();
          a.remove();
        })
        .catch((err) => {
          console.log("Error: ", err);
        });
      }
  };

  return (
    <>
      <div>
        <Button
          primary
          size="small"
          className="headerBtn"
          onClick={handleShowOptions}
        >
          <img
            src={profile}
            className="headerBtn--img headerBtn--img--left  "
            alt="profile icon"
          />
          {username}
          <img
            src={!showOptions ? gl_arrow_down : gl_arrow_up}
            className="headerBtn--img headerBtn--img--right "
            alt="chevrot icon"
          />
        </Button>
      </div>
      <ul
        className={`buttonheaderdesktop-menu ${
          showOptions ? "appear" : "disappear"
        }`}
      >
        <li
          className="paragraph paragraph-14 text-center"
          onClick={handleLogout}
        >
          Cerrar sesión
        </li>
      </ul>
      <div>
      <Button
          primary
          size="small"
          onClick={downloadManual}
          title="Manual de Usuario"
        >
          <img
            src={manual}
            className="headerBtn--img-medium headerBtn--img--left  "
            alt="manual icon"
          />
        </Button>

      </div>
    </>
  );
};

ButtonHeaderDesktop.defaultProps = {
  username: "UTEST",
};

ButtonHeaderDesktop.propTypes = {
  username: PropTypes.string,
};

export default ButtonHeaderDesktop;
